import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const discoverySectionStyles = {
  design: (): SystemStyleObject<Theme> => ({
    display: "grid",
    mx: "auto",
    gap: 2,
  }),

  leftColumn: (): SystemStyleObject<Theme> => ({
    display: "flex",
    alignItems: "center",
    gap: { xs: 2, lg: 4 },
    width: "min-content",
    height: "fit-content",
  }),
  leftHeading: (): SystemStyleObject<Theme> => ({
    mb: { xs: 1, md: 2 },
    fontWeight: 600,
    textAlign: { xs: "left" },
  }),
  leftSubheading: (
    theme: Theme,
    { isVisible }: { isVisible?: boolean },
  ): SystemStyleObject<Theme> => ({
    color: theme.palette.grey[400],
    fontWeight: 400,
    pointerEvents: isVisible ? "none" : "all",
    opacity: isVisible ? 1 : 0,
  }),

  cardWrapper: (): SystemStyleObject<Theme> => ({
    willChange: "transform",
    width: "min(90vh, 100%)",
    mx: "auto",
  }),

  rightContent: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.grey[300],
    fontWeight: 400,
    lineHeight: "1.3",
    fontSize: 20,
    textAlign: "justify",
    gridColumn: 1,
    gridRow: 1,
  }),

  banner: (theme: Theme): SystemStyleObject<Theme> => ({
    gridColumnStart: 1,
    gridColumnEnd: -1,
    py: { xs: 1, md: 2 },
    overflowX: "hidden",
    mt: 3,
    background: theme.palette.primary.dark,

    [theme.breakpoints.up("lg")]: {
      mt: 6,
    },
  }),
  bannerDivider: (theme: Theme): SystemStyleObject<Theme> => ({
    height: 4,
    width: "100%",
    backgroundColor: theme.palette.background.default,
  }),
  bannerTextWrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.background.default,
    fontWeight: 700,
    whiteSpace: "nowrap",
    textTransform: "uppercase",
  }),
  outlineText: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.primary.dark,
    textShadow: `
      -4px -4px 0 ${theme.palette.background.default},
      4px -4px 0 ${theme.palette.background.default},
      -4px 4px 0 ${theme.palette.background.default},
      4px 4px 0 ${theme.palette.background.default}
    `,
  }),
  bannerText: (theme: Theme): SystemStyleObject<Theme> => ({
    display: "inline-flex",
    alignItems: "center",

    "&::after": {
      content: "''",
      display: "inline-block",
      width: 35,
      height: 10,
      mx: 3,
      backgroundColor: theme.palette.background.default,
    },

    "&:last-of-type": {
      "&::after": {
        display: "none",
      },
    },
  }),
};

export default discoverySectionStyles;
